export const CRONS_STATUS_OPS = {
	ALL: 'All',
	RUNNING: 'Running',
	FINISHED: 'Finished',
	ERRORED: 'Errored',
};

export const CRONS_POLLING_INTERVAL = 1000 * 5;
